import { render } from "./AddKinkekaart.vue?vue&type=template&id=77b73860&scoped=true"
import script from "./AddKinkekaart.vue?vue&type=script&lang=js"
export * from "./AddKinkekaart.vue?vue&type=script&lang=js"

import "./AddKinkekaart.vue?vue&type=style&index=0&id=77b73860&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b73860"]])

export default __exports__